import React, { useEffect, useState } from "react";
import { DashboardShell } from "@/components/DashboardLayout";
import { BackButton } from "@/components/Layout";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { api, fmtSASTDate, fmtSASTDateTime, fmtZAR } from "@/lib/api";

const COLOR = {
  active: "bg-[#00C853]/10 text-[#00C853] border-[#00C853]/30",
  partially_redeemed: "bg-[#00C4B4]/10 text-[#00C4B4] border-[#00C4B4]/30",
  fully_redeemed: "bg-gray-100 text-gray-500 border-gray-200",
  expired: "bg-orange-100 text-orange-700 border-orange-200",
  cancelled: "bg-red-50 text-red-700 border-red-200",
  suspended: "bg-yellow-50 text-yellow-700 border-yellow-200",
};

export default function AdminVouchers() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/admin/vouchers").then(({ data }) => setList(data.vouchers || [])); }, []);
  const outstanding = list.filter(v => v.status === "active" || v.status === "partially_redeemed").reduce((s, v) => s + v.balance, 0);
  return (
    <DashboardShell role="admin">
      <BackButton to="/admin" />
      <p className="text-xs tracking-[0.22em] uppercase font-bold text-[#00C4B4]">Voucher liabilities</p>
      <h1 className="font-display mt-2 text-3xl font-bold text-[#0A2540]">All vouchers ({list.length})</h1>
      <p className="text-sm text-[#666666] mt-1">Outstanding stored-value balance: <strong className="text-[#0A2540]">{fmtZAR(outstanding)}</strong></p>

      <div className="mt-6 bg-white border border-[#E5E7EB] rounded-2xl overflow-x-auto">
        <Table data-testid="admin-vouchers-table">
          <TableHeader>
            <TableRow>
              <TableHead>Created</TableHead>
              <TableHead>PIN</TableHead>
              <TableHead>Service</TableHead>
              <TableHead>Original</TableHead>
              <TableHead>Balance</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Expires</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {list.length === 0 && <TableRow><TableCell colSpan={7} className="text-center py-8 text-[#666666]">No vouchers</TableCell></TableRow>}
            {list.map((v) => (
              <TableRow key={v.id}>
                <TableCell className="text-xs">{fmtSASTDateTime(v.created_at)}</TableCell>
                <TableCell className="font-mono text-sm">{v.pin_masked}</TableCell>
                <TableCell className="text-xs uppercase">{v.intended_service}</TableCell>
                <TableCell className="font-mono">{fmtZAR(v.original_amount)}</TableCell>
                <TableCell className="font-mono font-semibold text-[#00C853]">{fmtZAR(v.balance)}</TableCell>
                <TableCell><Badge className={`border ${COLOR[v.status] || ""}`}>{v.status.replace("_", " ")}</Badge></TableCell>
                <TableCell className="text-xs">{fmtSASTDate(v.expires_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </DashboardShell>
  );
}
